// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKBadge from "components/MKBadge";
import MKTypography from "components/MKTypography";

// Presentation page components
import SimpleBookingCard from "custom/Cards/BookingCards/SimpleBookingCard";

function ServiceBlocks() {
  const services = [
    {
      title: "Red Team & Preparación",
      description:
        "Diseñado para empresas maduras, estas actividades tienen como objetivo identificar vulnerabilidades y mejorar la preparación para enfrentar eficazmente los desafíos actuales.",
      route: "/services/red-team",
    },
    {
      title: "Seguridad de Red",
      description:
        "Examinar minuciosamente las redes ayuda a descubrir debilidades explotables, permitiendo correcciones proactivas de vulnerabilidades que mejoran la resiliencia de la red contra amenazas cibernéticas.",
      route: "/services/internal-pentesting",
    },
    {
      title: "Seguridad de Aplicaciones",
      description:
        "Evaluaciones exhaustivas de aplicaciones web, móviles, híbridas y Web 3.0 / blockchains para identificar vulnerabilidades y prevenir posibles explotaciones por parte de atacantes.",
      route: "/services/web-pentesting",
    },
    {
      title: "Seguridad en la Nube",
      description:
        "Evaluar la seguridad en la nube implica examinar sistemas y servicios basados en la nube, no solo las aplicaciones alojadas, sino también las configuraciones.",
      route: "/services/cloud-security",
    },
    {
      title: "Gestión de Vulnerabilidades",
      description:
        "Monitoreo y evaluación continuos para identificar, priorizar y remediar vulnerabilidades en tus sistemas y aplicaciones.",
      route: "/services/vulnerability-management",
    },
    {
      title: "Formación y Concienciación",
      description:
        "Proporcionar programas de formación completos para equipar a tu equipo con el conocimiento y las habilidades necesarias para defenderse contra amenazas cibernéticas.",
      route: "/services/training-education",
    },
  ];

  // Calcular la longitud máxima de las descripciones
  const maxDescriptionLength = Math.max(
    ...services.map(service => service.description.length)
  );

  // Rellenar las descripciones con espacios no separables para asegurar una longitud uniforme
  const paddedServices = services.map(service => ({
    ...service,
    description: service.description.padEnd(maxDescriptionLength, '\u00A0'),
  }));

  return (
    <MKBox component="section" my={0} py={0} mb={12}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          flexDirection="column"
          alignItems="center"
          sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
        >
          <MKBadge
            variant="contained"
            color="info"
            badgeContent="Explora nuestros servicios"
            container
            sx={{ mb: 3 }}
          />
          <MKTypography variant="h2" fontWeight="bold">
            Todo lo que necesitas
          </MKTypography>
          <MKTypography variant="body1" color="text" mt={3}>
            Hemos creado un catálogo de servicios personalizado para satisfacer las necesidades únicas de nuestros clientes.
          </MKTypography>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={3} alignItems="stretch" sx={{ mt: 3 }}>
          {paddedServices.map((service, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <MKBox mt={3} height="100%" display="flex" flexDirection="column" justifyContent="space-between">
                <SimpleBookingCard
                  title={service.title}
                  description={
                    <MKBox flexGrow={1} display="flex" flexDirection="column" justifyContent="space-between">
                      <MKTypography
                        variant="body2"
                        color="text"
                        sx={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 6, 
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {service.description}
                      </MKTypography>
                    </MKBox>
                  }
                  action={{
                    type: "internal",
                    route: service.route,
                    color: "info",
                    label: "Leer más",
                  }}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                />
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ServiceBlocks;